import { render } from "./menu.vue?vue&type=template&id=4c4c30bd"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=4c4c30bd&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script